import React from 'react';
import ChevronGray from '../../../../Assets/StorefrontIcons/ChevronGray.svg';

function LinkButton({ handlerFunction, title }) {
    return (
        <button onClick={handlerFunction} className="outline-none text-left border border-[#EAEAEA] bg-[#F5F5F5] flex items-center gap-[10px] p-3 rounded-[9px]">
            <p className='w-[calc(100%-24px)] font-normal text-base text-[#666666]'>
                {title}
            </p>

            <div className="size-6 flex items-center justify-center">
                <img src={ChevronGray} alt="" />
            </div>
        </button>
    )
}

export default LinkButton;
